import React from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';

interface HeaderProps {
  onNavigateHome: () => void;
}

const Header: React.FC<HeaderProps> = ({ onNavigateHome }) => {
  const { t } = useTranslation();

  return (
    <img
      src="/logo.png"
      alt="TransparencyChain Logo"
      className="header-logo"
      onClick={onNavigateHome}
      title={t('nav.home') || 'Home'}
    />
  );
};

export default Header;